import modelBaseV2 from '../model-base-v2.model';
import moment from 'moment';

const goodMovementModel = {
  isFromPOSMGoodMovement: false,
  isGoingtoHierachy: false,
  movementDetail: {
    main: { id: null, code: null, name: null },
    goodsType: { id: null, code: null, name: null },
    division: { id: null, code: null, name: null },
    model: { id: null, code: null, name: null },
    basicModel: { id: null, code: null, name: null },
    movementType: { code: null, name: null },
    warehouse: { code: null, name: null },
    storageLocation: { code: null, name: null },
  },
  taiwanHierachyLabel: [['Main', 'LT00001266'], ['Goods Type', 'LT00001267'], ['Division', 'LT00000233'], ['Model', 'LT00000717'], ['Basic Model', 'LT00001268']],
  SEAOHierachyLabel: [['Division', 'LT00000233'], ['Asset Category', 'LT00001286'], ['Asset Type', 'LT00001287'], ['Item Type', 'LT00001288'], ['Item Name', 'LT00001251']],
  main: [],
  goodsType: [],
  division: [],
  model: [],
  basicModel: [],
  warehouse: [],
  storageLocation: [],
  createHierachyOptions: function (hierachyArray) {
    const result = [];
    if (!hierachyArray?.length) {
      return result;
    }

    hierachyArray?.map((item) => {
      const hierachyObj = { id: item.id, code: item.code, name: item.name, IsExpiry: item.isExpiry }
      result.push(hierachyObj)
    })
    return result;
  },
  resetMovementDetail: function () {
    for (const prop in this.movementDetail) {
      this.movementDetail[prop] = { code: null, name: null }
    }
    this.main = [];
    this.goodsType = [];
    this.division = [];
    this.model = [];
    this.basicModel = [];
    this.warehouse = [];
    this.storageLocation = [];
  },
  setHierachyOptions: function (name, hierachyArray) {

    this[name] = this.createHierachyOptions(hierachyArray);
  },
  setMovementDetail: function (newMovementDetail) {
    this.movementDetail = { ...this.movementDetail, ...newMovementDetail };
  },
  getMovementDetail: function () {
    return this.movementDetail;
  },
  addHierachyDetail: function (hierachyObj) {
    return modelBaseV2.post(
      '/api/posmMaster/insertOrUpdateCate',
      {
        body: hierachyObj,
      }
    );
  },
  getHierachyTreeByLevel: function (fromLevel, toLevel) {
    return modelBaseV2.get(
      '/api/posmMaster/getHierarchyTree',
      {
        params: { fromLevel, toLevel },
      }
    );
  },
  getHierachyTreeByParentCode: function (parentId) {
    return modelBaseV2.get(
      '/api/posmMaster/getCatesByParentId',
      {
        params: { parentId },
      }
    );
  },
  addPosmStorageLocation: function (storageObj) {
    return modelBaseV2.post('/api/posmMaster/storageLocation',
      {
        body: { ...storageObj }
      }
    );
  },
  getCommonForPopup: function (params) {
    return modelBaseV2.get('/api/posmMaster/getCommonCodeNameForPopup',
      {
        params: { ...params }
      }
    )
  },
  getListGoodMovement: function (params) {
    return modelBaseV2.get('/api/goodsMovement/list',
      {
        params: { ...params }
      }
    )
  },
  downloadGoodMaster: function (filter) {
    let fileName = `Goodmaster List - ${moment().format('YYYYMMDDHHmm')}.xlsx`
    let params = {};
    params.storedProcedureCode = "70";
    params.params = [
      { code: "3", value: "1" },
      { code: "4", value: "-1" },
      { code: "138", value: `${filter.DateFrom}` || "" },
      { code: "139", value: `${filter.DateTo}` || "" },
      { code: "142", value: filter.GoodsTypeId ? `${filter.GoodsTypeId}` : "" },
      { code: "141", value: filter.DivisionId ? `${filter.DivisionId}` : "" },
      { code: "140", value: filter.ModelId ? `${filter.ModelId}` : "" },
      { code: "137", value: filter.BasicModelId ? `${filter.BasicModelId}` : "" },

    ];
    return modelBaseV2.postDownload('/api/survey/export/tr/file', { body: params }, fileName);
  },
  downloadGoodMovement: function (filter) {
    let fileName = `Goods Movement List - ${moment().format('YYYYMMDDHHmm')}.xlsx`
    let params = {};
    params.storedProcedureCode = "68";
    params.excelSheetNames = ["Count", "Data"]
    params.params = [
      { code: "138", value: filter.DateFrom || "" },
      { code: "139", value: filter.DateTo || "" },
      { code: "3", value: "1" },
      { code: "4", value: "-1" },
      { code: "2", value: "" },
      { code: "24", value: "" },
      { code: "142", value: filter.GoodsTypeId ? `${filter.GoodsTypeId}` : "0" },
      { code: "141", value: filter.DivisionId ? `${filter.DivisionId}` : "0" },
      { code: "140", value: filter.ModelId ? `${filter.ModelId}` : "0" },
      { code: "152", value: filter.MovementTypeCode || "" },
      { code: "143", value: filter.WarehouseCode || "" },
      { code: "144", value: filter.StorageLocationCode || "" },
      { code: "153", value: filter.MovementBy || "" },
      { code: "145", value: filter.ChannelCd || "" },
      { code: "154", value: filter.VendorID || "" },
      { code: "155", value: filter.BasicModelId ? `${filter.BasicModelId}` : "0" },
      { code: "151", value: filter.MainId ? `${filter.MainId}` : "0" },
    ];
    return modelBaseV2.postDownload('/api/survey/export/tr/file', { body: params }, fileName);
  },
  addGoodsMovement: function (body) {
    return modelBaseV2.post('/api/goodsMovement/goodsMovementAdd', { body })
  },
  getGoodsMovementHeader: function (params) {
    const qs = modelBaseV2.toQueryString(params)
    return modelBaseV2.get(`/api/goodsMovement/getHeader?${qs}`)
  },
  getChannelGoodsQty: function (params) {
    return modelBaseV2.get('/api/goodsMovement/channelGoodsQty', { params })
  },
  uploadRetailQty: function (body) {
    return modelBaseV2.post('/api/goodsMovement/channelGoodsQtyExcel', { body })
  },
  downloadRetailQtyTemplate: function () {
    return modelBaseV2.getDownload('/api/goodsMovement/channelQtyTemplate/download', {}, 'POSM_CHANNEL_QTY_Template')
  },
  getGoodsMovementDetail: function (params) {
    return modelBaseV2.get('/api/goodsMovement/goodsMovementGetDetail/:movementControlCode', { params })
  },
  downloadProofFile: (fileId, fileName) => {
    return modelBaseV2.getDownload("/api/goodsMovement/proofDownload", { params: { fileId } }, fileName);
  },
  updateGoodsMovement: function (body) {
    return modelBaseV2.post('/api/goodsMovement/goodsMovementUpdate', { body })
  },
  deleteGoodsMovement: function (movementControlCode) {
    return modelBaseV2.post('/api/goodsMovement/goodsMovementDelete/:movementControlCode', { params: { movementControlCode } })
  },
  getGoodMasterList: function (params) {
    let query = modelBaseV2.toQueryString(params)
    return modelBaseV2.get(`/api/goodsMovement/getListGoodsDetails?${query}`)
  },
  deleteWarehouse: function (warhouseId) {
    return modelBaseV2.post('/api/posmMaster/storageLocation',
      {
        body: { WarehouseId: warhouseId, Type: "Warehouse", Action: "DELETE", CateName: "test" }
      })
  },
  updateWarehouse: function (warhouseId, warehouseName) {
    return modelBaseV2.post('/api/posmMaster/storageLocation',
      {
        body: { WarehouseId: warhouseId, Type: "Warehouse", Action: "UPDATE", CateName: warehouseName }
      })
  },
  checkUserMovementWarehouseMapAuthorization: function (params) {
    return modelBaseV2.get('/api/posmAuthorization/checkAuthorizeWM', { params })
  }

}

export default goodMovementModel;
